import { COOKIES } from '@/constants/cookies.constants.js'

const cookieName = 'rt_cookies'
const durationMonths = 6

function saveConsent(categories = [], isConsented = null) {
  const value = JSON.stringify({
    categories: [COOKIES.NECESSARY, ...categories],
    isConsented,
    timestamp: Date.now()
  })

  const maxAge = durationMonths * 30 * 24 * 60 * 60

  document.cookie = `${cookieName}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}`
}

function getConsent() {
  const match = document.cookie.match(new RegExp(`${cookieName}=([^;]*)`))

  if (!match) return null

  try {
    return JSON.parse(decodeURIComponent(match[1]))
  } catch {
    return null
  }
}

function hasConsentFor(category) {
  const consent = getConsent()

  return consent?.categories?.includes(category)
}

function clearConsent() {
  document.cookie = `${cookieName}=; Path=/; Expires=${new Date(0).toUTCString()}; SameSite=Lax`
}

export const consent = {
  save: saveConsent,
  get: getConsent,
  has: hasConsentFor,
  clear: clearConsent,
  cookies: COOKIES
}

export default {
  install(app) {
    app.provide('consent', consent)
  }
}
